package com.dotdrives.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.*

@Serializable data class WorkflowRequest(val endpoint: String, val body: JsonObject)

@Serializable
data class WorkflowJob(
    val id: String,
    val kind: String,
    val source: JsonObject = buildJsonObject {},
    val status: String,
    val attempts: Int = 0,
    @SerialName("source_label") val sourceLabel: String? = null,
    @SerialName("accepted_at") val acceptedAt: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    val retryable: Boolean = false,
    @SerialName("error_code") val errorCode: String? = null,
) {
    val label: String
        get() =
            when (status) {
                "accepted" -> "Accepted by email provider"
                "processing" -> "Processing"
                "failed" ->
                    if (errorCode == "reconciliation_required") "Needs delivery review"
                    else "Failed"
                "skipped" -> "Not sent"
                "completed" -> "Completed"
                else -> "Queued"
            }

    fun references(id: String): Boolean = source.values.any { it.jsonPrimitive.contentOrNull == id }
}

fun JsonObject.text(key: String): String? = this[key]?.jsonPrimitive?.contentOrNull

fun JsonObject.flag(key: String): Boolean = this[key]?.jsonPrimitive?.booleanOrNull == true

fun canAdminister(role: String): Boolean = role == "owner" || role == "admin"

class WorkflowFailure(val code: String?, message: String) : IllegalStateException(message)

/** Only explicitly sanitized endpoint errors may become product copy. */
fun Throwable.workflowMessage(fallback: String): String =
    if (this is WorkflowFailure) message ?: fallback else fallback
